function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import qs from 'query-string';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
var toPathObj = function toPathObj(path) {
  var _path$split = path.split(/[#?]/),
    _path$split2 = _slicedToArray(_path$split, 1),
    pathname = _path$split2[0];
  var search = '';
  var hash = '';
  if (pathname) {
    path = path.slice(pathname.length);
  }
  if (path.startsWith('?')) {
    search = path.split('#')[0];
    hash = path.slice(search.length);
  } else if (path.startsWith('#')) {
    hash = path;
  }
  return {
    pathname: pathname || undefined,
    search: search || undefined,
    hash: hash || undefined
  };
};
var toV6Params = function toV6Params(location, state) {
  if (typeof location === 'string') {
    return {
      to: toPathObj(location),
      state: state
    };
  }
  var _toPathObj = toPathObj(location.pathname || ''),
    pathname = _toPathObj.pathname,
    search = _toPathObj.search,
    hash = _toPathObj.hash;
  return {
    to: {
      pathname: pathname,
      search: _typeof(location.search) === 'object' ? location.search instanceof URLSearchParams ? location.search.toString() : qs.stringify(location.search) : location.search || search,
      hash: location.hash || hash
    },
    state: location.state || state
  };
};
export var useHistory = function useHistory() {
  var navigate = useNavigate();
  var push = useCallback(function (location, state) {
    var p = toV6Params(location, state);
    navigate(p.to, {
      state: p.state
    });
  }, [navigate]);
  var replace = useCallback(function (location, state) {
    var p = toV6Params(location, state);
    navigate(p.to, {
      state: p.state,
      replace: true
    });
  }, [navigate]);
  var go = useCallback(function (n) {
    navigate(n);
  }, [navigate]);
  var goBack = useCallback(function () {
    navigate(-1);
  }, [navigate]);
  var goForward = useCallback(function () {
    navigate(1);
  }, [navigate]);
  return {
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward
  };
};